































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ProjectCard extends Vue {
  @Prop() private joinEnable!: boolean;
  @Prop() private onClickJoin!: Function;
  @Prop() private needLogin!: boolean;

  showNeedLoginPopup () {
    alert('ログインすると利用できます')
  }
}
